import React from "react";
import dayjs from "dayjs";
import { IconArrowUp } from "../../../../utils/Icons";
import withPurchase from "../../../../hoc/withPurchase";
import { HeaderPhoneUi } from "../../../../components/ui";
import { monthsMedium } from "../../../../utils/monthsLists";
import { useCustomLocale } from "../../../../hooks/useCustomLocale";

function Result({ type, state, mobile, transferList }) {
  useCustomLocale("ru", monthsMedium);

  return (
    <>
      <img
        src={require(`../../../../assets/img/generator/wallets/trustwallet/history/history-${type}-${state.theme}.png`)}
        className="img-fluid img-thumbnail"
        width="100%"
        alt=""
      />

      <HeaderPhoneUi type={type} mode={state.theme} {...mobile} />

      <div className="transfers">
        {transferList &&
          transferList.map((item, i) => (
            <div className={`item ${item.today ? "today" : ""}`} key={i}>
              <b>
                {item.date
                  ? dayjs(item.date).format("MMM D YYYY") ===
                    dayjs().format("MMM D YYYY")
                    ? "Сегодня"
                    : dayjs(item.date).format("MMM D YYYY") ===
                      dayjs().add(-1, "day").format("MMM D YYYY")
                    ? "Вчера"
                    : dayjs(item.date).format("MMM D YYYY")
                  : "янв. 1 2024"}
              </b>
              <div className="content">
                <div className="left-side">
                  <i className={`icon ${item.type}`}>
                    <IconArrowUp width="43" height="43" fill="#848E9C" />
                  </i>
                  <span>
                    Перевод
                    <small>
                      {item.type === "received" ? "С: " : "На: "}
                      {item.wallet?.slice(0, 7)}
                      {"..."}
                      {item.wallet?.slice(item.wallet?.length - 7)}
                    </small>
                  </span>
                </div>
                <div className={`right-side ${item.type}`}>
                  {item.type === "received" ? "+" : "-"}
                  {new Intl.NumberFormat("ru", {
                    maximumSignificantDigits: 20,
                  }).format(item.amount || 0)}{" "}
                  {state.currency.value}
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default withPurchase(Result, {
  className: "result-img trust history",
});
